﻿export class NoDownloadPermissionDialog {
    public show(): void {
        var modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalContent = $('<div class="modal-content"></div>')
            .appendTo($('<div class="modal-dialog"></div>').appendTo(modal));

        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        $('<h4 class="modal-title"></h4>').text('Data Download Permission').appendTo(modalHeader);

        var modalBody = $('<div class="modal-body"></div>')
            .appendTo(modalContent)
            .append($('<p></p>').text("You do not have data download permission. Please contact your administrator to request permission to download data."));
        
        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">OK</button>').appendTo(modalFooter);
        modal.modal('show');
    }
}